// Reexport the native module. On web, it will be resolved to LegacyKitModule.web.ts
// and on native platforms to LegacyKitModule.ts
export { default } from "./src/LegacyKitModule";
export { legacyKitLifecycle } from "./src/LegacyKitLifecycle";

// Export a convenience function to present the legacy app
import LegacyKitModule from "./src/LegacyKitModule";

export async function presentLegacyApp(): Promise<void> {
  // @ts-expect-error baseline 2026-02-16
  return LegacyKitModule.presentLegacyApp();
}

export interface LegacyKitConfig {
  apiBaseUrl: string;
}

export function configure(config: LegacyKitConfig): void {
  // @ts-expect-error baseline 2026-02-16
  return LegacyKitModule.configure(config);
}
